// extracted by mini-css-extract-plugin
module.exports = {"container":"ReturnSample_container_19F9L","containerGrid1":"ReturnSample_containerGrid1_1s3LU","containerGrid2":"ReturnSample_containerGrid2_DYEZn"};